import React from "react"
import CustomPageHeader from "../fragments/CustomPageHeader"
 
export default function Bundles({ children }) {
  return (
    <div>
      <CustomPageHeader icon='bookmark' text='Bundles' />
      { children }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Bundles/index.js